import React, { useMemo } from 'react';
import { Table, Tag } from 'antd';
import { SCROLL_Y } from 'constants/table';
import { thousandFormatter } from 'utils/forms/formatter';
import { numberToMonth } from 'utils/handbooks/statisticsHanbooks';
import { FilterOutlined } from '@ant-design/icons';

function SalesTable({ items, loading, firstColName }) {
  const columns = [
    {
      title: firstColName,
      dataIndex: 'package',
      key: 'package',
    },
    {
      title: 'Тип',
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
        const typeToText = {
          package: 'Тариф',
          service: 'Услуга',
        };

        return type ? (
          <Tag color={type === 'package' ? 'purple' : ''}>
            {typeToText[type]}
          </Tag>
        ) : (
          '---'
        );
      },
      filters: [
        {
          text: 'Тариф',
          value: 'package',
        },
        {
          text: 'Услуга',
          value: 'service',
        },
      ],
      onFilter: (value, record) => record?.type === value,
      filterIcon: () => <FilterOutlined />,
    },
    {
      title: 'Сегодня',
      dataIndex: 'today',
      key: 'today',
    },
    {
      title: 'За все время',
      dataIndex: 'all',
      key: 'all',
      render: (value) => thousandFormatter(value),
    },
  ];

  const getDynamicColumns = () => {
    const firstItem = items[0];
    const copyColumns = [...columns];
    const columnsFirstHalf = copyColumns.slice(0, 2);
    const columnsSecondHalf = copyColumns.slice(2);

    Object.keys(firstItem).forEach((value) => {
      const singleColumn = {};

      if (!Number.isNaN(parseInt(value, 10))) {
        singleColumn.title = numberToMonth[value];
        singleColumn.dataIndex = value;
        singleColumn.key = value;
        singleColumn.render = (value) => thousandFormatter(value);

        columnsFirstHalf.push(singleColumn);
      }
    });

    return [...columnsFirstHalf, ...columnsSecondHalf];
  };

  const tableColumns = useMemo(() => {
    if (items.length) {
      return getDynamicColumns();
    }

    return columns;
  }, [items]);

  return (
    <Table
      columns={tableColumns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y }}
      pagination={false}
      rowKey="id"
    />
  );
}

export { SalesTable };
